/**
 * Frontend Logger Utility
 * Provides consistent logging across the frontend application
 * In production, only errors are logged
 */

const isDevelopment = process.env.NODE_ENV === 'development';

class Logger {
  constructor() {
    this.isDevelopment = isDevelopment;
  }

  debug(message, ...args) {
    if (this.isDevelopment) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  }

  info(message, ...args) {
    if (this.isDevelopment) {
      console.log(`[INFO] ${message}`, ...args);
    }
  }

  warn(message, ...args) {
    console.warn(`[WARN] ${message}`, ...args);
  }

  error(message, error, ...args) {
    const errorDetails = error instanceof Error 
      ? { message: error.message, stack: error.stack, ...error }
      : error;
    console.error(`[ERROR] ${message}`, errorDetails, ...args);
  }

  // Specialized loggers
  api(method, url, status, duration) {
    if (this.isDevelopment) {
      this.info(`[API] ${method} ${url} ${status} ${duration}ms`);
    }
  }

  service(serviceName, action, details) {
    if (this.isDevelopment) {
      this.debug(`[SERVICE:${serviceName}] ${action}`, details);
    }
  }
}

// Export singleton instance
const logger = new Logger();
export default logger;
